type EventHandler<T = any> = (payload: T) => void;

class EventBus {
    private listeners: Record<string, EventHandler[]> = {};

    on<T = any>(event: string, handler: EventHandler<T>): void {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(handler);
    }

    off<T = any>(event: string, handler: EventHandler<T>): void {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event].filter(h => h !== handler);
    }

    emit<T = any>(event: string, payload?: T): void {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach(handler => handler(payload));
    }
}

export const eventBus = new EventBus();

// Event Types for type safety
export const TaskEvents = {
    START: 'TASK_START',
    STOP: 'TASK_STOP',
    TOGGLE: 'TASK_TOGGLE',
    UPDATE: 'TASK_UPDATE', // Generic update
    CREATE: 'TASK_CREATE',
    CREATED: 'TASK_CREATED',
    DELETE: 'TASK_DELETE',
} as const;

export const StockEvents = {
  CREATE: 'STOCK_CREATE',
  UPDATE: 'STOCK_UPDATE',
  DELETE: 'STOCK_DELETE',
  RECORD_USAGE: 'STOCK_RECORD_USAGE',
  ADD_STOCK: 'STOCK_ADD_STOCK',
} as const;

export const MealEvents = {
  RECIPE_CREATE: 'MEAL_RECIPE_CREATE',
  RECIPE_UPDATE: 'MEAL_RECIPE_UPDATE',
  RECIPE_DELETE: 'MEAL_RECIPE_DELETE',
  PLAN_CREATE: 'MEAL_PLAN_CREATE',
  PLAN_UPDATE: 'MEAL_PLAN_UPDATE',
  PLAN_DELETE: 'MEAL_PLAN_DELETE',
  PLAN_COOK: 'MEAL_PLAN_COOK',
  ATTENDEE_SET: 'MEAL_ATTENDEE_SET',
  ATTENDEE_REMOVE: 'MEAL_ATTENDEE_REMOVE',
} as const;

export const NavigationEvents = {
  GO_TO_TAB: 'NAV_GO_TO_TAB',
} as const;

export interface NavigationPayload {
  tab: string;
  searchQuery?: string;
}

export const SettingsEvents = {
  /** Open the Settings modal, optionally to a specific tab (e.g. 'failed-sync'). */
  OPEN: 'SETTINGS_OPEN',
} as const;

export interface SettingsOpenPayload {
  /** Settings tab to open directly. Currently only 'failed-sync' is deep-linked. */
  tab?: 'failed-sync';
}

export interface TaskEventPayload {
  taskId: string;
  task?: any;
  completedBy?: string;
}
